import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { ProveedorDistribuidorContent } from './components/ProveedorDistribuidorContent';

export default function ProveedorDistribuidorSearch() {

    return (
        <MainContent component={<ProveedorDistribuidorContent/>} titulo='Proveedores de distribución' />
    );

};